import { CamelCaseKeys } from '@utils/typescript';
import { ClaimStatuses } from '@models/Claim';
import { tEnum } from '@components/i18n';
import { PaymentInfo } from '@models/PaymentInfo';

export type HealthClaim = CamelCaseKeys<{
  id: number;
  status: ClaimStatuses;
  accident_happened_at: string;
  completed_claim_forms: string[];
  supporting_documents: string[];
  additional_documents: string[];
  invoice: string;
  total_claimed_amount: number;
  approved_amount: number;
  note: string;
  claim_number: string;
  payment_info: PaymentInfo;
  claim_type?: HealthClaimTypes;
}>;

export enum HealthClaimTypes {
  IpdHospitalRoomAndBoard = 'ipd_hospital_room_and_board',
  IpdIcuAndSimilar = 'ipd_icu_and_similar',
  IpdHospitalGeneralExpenses = 'ipd_hospital_general_expenses',
  IpdSurgicalBenefits = 'ipd_surgical_benefits',
  IpdPsychiatricCare = 'ipd_psychiatric_care',
  IpdCashAllowance = 'ipd_cash_allowance',
  IpdEmergencyTransportationFee = 'ipd_emergency_transportation_fee',

  OpdBenefits = 'opd_benefits',
  OpdPrescribed = 'opd_prescribed',

  HealthCheckupBenefits = 'health_checkup_benefits',

  DentalBenefits = 'dental_benefits',

  MaternityBenefits = 'maternity_benefits',

  VisionBenefits = 'vision_benefits',

  CopayBenefits = 'copay_benefits',

  OtherPreExistingCondition = 'other_pre_existing_condition',
  OtherChronicCondition = 'other_chronic_condition',
  OtherAidHiv = 'other_aid_hiv',
  OtherCongenitalCondition = 'other_congenital_condition',
  OtherCovid19 = 'other_covid19',
}

export const getHealthClaimType = (type: HealthClaimTypes) => tEnum('corporateHealthClaimTypes', type);
